import { Component, Input, ViewChild } from '@angular/core';
import { BcModalComponent } from '@bancolombia/design-system-web/bc-modal';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent {

  @ViewChild('modalShared', { static: false })
  bcModalComponent!: BcModalComponent

  @Input()
  bandera: boolean = false;

  @Input()
  title: string = '';

  @Input()
  typeIcon: 'error' | 'success' | 'warning' | 'info' | 'default' = 'error';

  @Input()
  customWidth: 'small' | 'medium' | 'large' = 'small'

  @Input()
  body: string = ''

  @Input()
  subBody: string = ''

  action = false;


  ngOnChanges() {
    this.isModal(this.bandera);
  }

  isModal(openModal: boolean): void {
    if (openModal) {
      this.showModal();
    }else{
      this.hideModal();
    }
  }

  showModal(): void {
    this.bcModalComponent.openModal();
  }

  hideModal(): void {
    this.bcModalComponent.shutDown();
  }
}
